import { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Title, VoteContainer, StyledToggle, ThumbsUp, ThumbsDown, CloseContainer, Close } from './style'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import { useLocalStorage } from 'react-use'
import isMobile from 'shared/util/is-mobile'
import { Experiment, Variant } from 'react-optimize'

const LocaleBanner = () => {
    const { t, i18n } = useTranslation()
    const [dontShowAnymore, setDontShowAnymore] = useLocalStorage('dont-show-anymore', false)
    const [dontShow, setDontShow] = useState<boolean>(false)
    const [showBanner, setShowBanner] = useState<boolean>(false)
    const [liked, setLiked] = useState<boolean | undefined>(undefined)

    const enableBanner = () => {
        setShowBanner(true)
    }

    useEffect(() => {
        document.addEventListener('scroll', enableBanner)
        document.addEventListener('click', enableBanner)

        return () => {
            document.addEventListener('click', enableBanner)
            document.addEventListener('scroll', enableBanner)
        }
    }, [])

    const title = useMemo(() => {
        if (liked === undefined) {
            return <Title>{t('¿Cómo es la traducción?')}</Title>
        } else if (liked) {
            return <Title>{t('¡Gracias!')}</Title>
        } else {
            return <Title>{t('Aw, nos esforzaremos más...')}</Title>
        }
    }, [liked])

    useEffect(() => {
        if (liked !== undefined) {
            setTimeout(() => {
                setDontShowAnymore(true)
            }, 3000)
        }
    }, [liked])

    if (!i18n?.language?.toLowerCase().includes('es') && !i18n?.language?.toLowerCase().includes('pt')) return <></>

    if (dontShowAnymore) return <></>

    if (dontShow) return <></>

    if (!showBanner) return <></>

    return (
        <Experiment id="V_dqIuT4S4ims-29Fo4leQ">
            <Variant id="1">
                <Container isMobile={isMobile()}>
                    <CloseContainer>
                        <Close onClick={() => setDontShow(true)} />
                    </CloseContainer>
                    {title}
                    <VoteContainer>
                        <StyledToggle
                            onText={<ThumbsUp />}
                            offText={<ThumbsDown />}
                            isOn={liked}
                            width={140}
                            height={32}
                            clickOn={() => {
                                googleAnalyticsEvent({
                                    category: 'translation',
                                    action: 'satisfaction',
                                    label: true,
                                })
                                setLiked(true)
                            }}
                            clickOff={() => {
                                googleAnalyticsEvent({
                                    category: 'translation',
                                    action: 'satisfaction',
                                    label: false,
                                })
                                setLiked(false)
                            }}
                            background={'#000'}
                        />
                    </VoteContainer>
                </Container>
            </Variant>
        </Experiment>
    )
}

export default LocaleBanner
